import axios from '../axios';

export const all = (params = {}) => {
  return axios.get('/footer-links', { params });
};

export const getByLanguage = (language, params = {}) => {
  return axios.get(`/footer-links/by-language/${language}`, { params });
};

export const getBySection = (sectionIdentifier, params = {}) => {
  return axios.get(`/footer-links/by-section/${sectionIdentifier}`, { params });
};

export const show = (id, params = {}) => {
  return axios.get(`/footer-links/${id}`, { params });
};

export const store = (payload) => {
  return axios.post('/footer-links', payload);
};

export const update = (id, payload) => {
  return axios.put(`/footer-links/${id}`, payload);
};

export const updateOrCreate = (payload) => {
  return axios.post('/footer-links/update-or-create', payload);
};

export const destroy = (id) => {
  return axios.delete(`/footer-links/${id}`);
};
